import { Directive, Input, TemplateRef } from "@angular/core";

@Directive({
  selector: "[vpDynamicTemplate]",
  standalone: false
})
export class DynamicTemplateDirective {
  @Input("vpDynamicTemplate") id: string | undefined;
  constructor(public template: TemplateRef<any>) {}
}
